export const defaultReducer = (antState, newState) => {
    return {...antState, ...newState}
}


export const lockedReducer = (state, action) => {
    const returnActions = Object.fromEntries(Object.entries(action).filter(([key, value])=> key in state))
    return {...state, ...returnActions}
}
